export var AlgoliaIndexes;
(function (AlgoliaIndexes) {
    AlgoliaIndexes["NonProfit"] = "nonprofit";
    AlgoliaIndexes["Forms"] = "forms";
})(AlgoliaIndexes || (AlgoliaIndexes = {}));
